export default __webpack_public_path__ + "static/media/problem2.c75f8e62.png";